import { TypographyHeading, TypographyParagraph } from '../typography'
// @ts-ignore
import monaLisa from '#images/mona.webp'
import { twMerge } from 'tailwind-merge'
import Image from './Image'
import clsx from 'clsx'

const CollectionCard = ({
	name = 'Unknown',
	artist = 'Unknown',
	blockchain = 'Unknown',
	count = 0,
	image = monaLisa,
	cardAdditionalProps = '',
	containerAdditionalProps = '',
	imageAdditionalProps = '',
	hasHoverEffect = true,
}: {
	name: string
	artist: string
	description: string
	blockchain: string
	count: number
	image: string
	cardAdditionalProps: string
	containerAdditionalProps: string
	imageAdditionalProps: string
	hasHoverEffect?: boolean
}) => {
	return (
		<div
			className={twMerge(
				'group h-[357px] w-[302px] border border-textInactiveLight dark:border-textInactiveDark dark:hover:border-textPrimaryDark',
				hasHoverEffect
					? 'cursor-pointer hover:border-textPrimaryLight dark:hover:border-textPrimaryDark'
					: '',
				cardAdditionalProps,
			)}
		>
			<Image
				className={twMerge(
					'h-[240px] w-[302px] object-cover',
					imageAdditionalProps,
				)}
				containerClassName={containerAdditionalProps}
				imageUrl={image}
				imageAlt={name}
			></Image>
			<TypographyHeading
				size="small"
				isBold={true}
				additionalClasses={clsx(
					'w-full h-10 px-4 py-2 text-textPrimaryLight dark:text-textPrimaryDark truncate border-t border-textInactiveLight dark:border-textInactiveDark',
					hasHoverEffect
						? 'group-hover:underline group-hover:border-textPrimaryLight dark:group-hover:border-textPrimaryDark'
						: '',
				)}
			>
				{name}
			</TypographyHeading>
			{artist && artist.length && (
				<div
					className={clsx(
						'flex h-10 gap-x-6 border-t border-textInactiveLight px-4 py-2 dark:border-textInactiveDark',
						hasHoverEffect
							? 'group-hover:border-textPrimaryLight dark:group-hover:border-textPrimaryDark'
							: '',
					)}
				>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Artist
					</TypographyParagraph>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{artist}
					</TypographyParagraph>
				</div>
			)}
			<div className="flex flex-row">
				<div
					className={clsx(
						'flex h-9 flex-1 justify-between border-r border-t border-textInactiveLight px-4 py-2 dark:border-textInactiveDark',
						hasHoverEffect
							? 'group-hover:border-textPrimaryLight dark:group-hover:border-textPrimaryDark'
							: '',
					)}
				>
					<TypographyParagraph
						size="small"
						additionalClasses="w-[84px] text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Blockchain
					</TypographyParagraph>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{blockchain}
					</TypographyParagraph>
				</div>
				<div
					className={clsx(
						'flex h-9 flex-1 justify-between border-t border-textInactiveLight px-4 py-2 dark:border-textInactiveDark',
						hasHoverEffect
							? 'group-hover:border-textPrimaryLight dark:group-hover:border-textPrimaryDark'
							: '',
					)}
				>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Size
					</TypographyParagraph>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{count > 10000 ? count.toLocaleString() : count}
					</TypographyParagraph>
				</div>
			</div>
		</div>
	)
}

export default CollectionCard
